import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import Dragula from '../../shared/components/Dragula'
import CarRow from './CarRow'
import CarOrder from './CarOrder'
import { triggerPopup } from '../../actions/backdrop'
import NewOrdersModal from '../../shared/modals/NewOrdersModal'
import StickyContainer from '../../shared/components/StickyContainer'
import './carrentaloverview.scss'

import { translation } from '../../utils/helpers'
import EventEmitter from '../../utils/events'

// actions
import { GetCarRentalOverview, MoveOrderCarRental, GetCarClasses, GetCarTypes } from '../../actions/carrental'
import { hasSubscriptionPermission } from '../../utils/auth'
import { openOverlay } from '../../actions/common'

// contants
import { CarRentalSystemTypes } from '../../constants'

// Elements
// import Null from '../../shared/elements/null'
// import TabBar from '../../shared/elements/tabBar'
import Inline from '../../shared/elements/inline'
import NextButton from '../../shared/elements/nextButton'
import PreviousButton from '../../shared/elements/previousButton'
import DropDown from '../../shared/elements/dropDown'

class CarRentalOverview extends Component {

  constructor (props) {
    super(props)
    this.state = {
      dimensions: {
        width: 0,
        height: 0
      },
      createOrderPopup: {
        show: false,
        defaultCreateOrderInfo: undefined
      },
      requestData: {
        CalendarView: 0,
        CalendarDirection: null,
        WeekType: 0,
        CurrentViewRange: null,
        OverviewSorting: 1,
        AvailableDaysNr: 0,
        CarRentalType: null,
        CarRentalCategory: null
      },
      CalendarData: {
        CalendarText: '',
        CalendarTextDictionaryKey: null
      },
      Days: [{
        Text: '',
        Active: false,
        IsClosed: false
      },
      {
        Text: '',
        Active: false,
        IsClosed: false
      },
      {
        Text: '',
        Active: false,
        IsClosed: false
      },
      {
        Text: '',
        Active: false,
        IsClosed: false
      },
      {
        Text: '',
        Active: false,
        IsClosed: false
      },
      {
        Text: '',
        Active: false,
        IsClosed: true
      },
      {
        Text: '',
        Active: false,
        IsClosed: true
      }],
      Cars: [],
      carTypes: [],
      carCategories: []
    }
    this.getCarRentalOverview = this.getCarRentalOverview.bind(this)
    this.setupDragula = this.setupDragula.bind(this)
    this.renderHeaderItems = this.renderHeaderItems.bind(this)
    this.dimensionShow = this.dimensionShow.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
    this.initiateMove = this.initiateMove.bind(this)
    this.setNewOverview = this.setNewOverview.bind(this)
    this.SetCreateNewOrderValues = this.SetCreateNewOrderValues.bind(this)
    this.renderAvailableDaysNr = this.renderAvailableDaysNr.bind(this)
    this.setLocalStorage = this.setLocalStorage.bind(this)
    this.getCarClasses = this.getCarClasses.bind(this)
    this.getCarTypes = this.getCarTypes.bind(this)

    this.dragula = null
    this.appElement = document.getElementById('app')
    // this.dragXStart = null
    // this.dragXDelta = null
    this.currentMirrorElement = null
    this.currentContainer = null
    // this.observer = null

    // socket
    this.updateFromOrderSocket = this.updateFromOrderSocket.bind(this)
  }
  // all the commented code is for later use, if we should use the horizontal drag
  componentDidMount () {
    window.addEventListener('resize', this.updateDimensions)
    EventEmitter.addListener('ORDER_SOCKET', this.updateFromOrderSocket, this)
    this.updateDimensions()
    this.getCarTypes()
    this.getCarClasses()
    let data = {
      CalendarView: 0,
      WeekType: 0,
      OverviewSorting: 1,
      AvailableDaysNr: 0,
      CarRentalType: null,
      CarRentalCategory: null
    }
    try {
      let storageData = JSON.parse(window.localStorage.getItem('carRentalOverviewSettings'))
      if (storageData !== undefined && storageData !== null) {
        data.CalendarView = parseInt(storageData.CalendarView)
        data.WeekType = parseInt(storageData.WeekType)
        data.OverviewSorting = parseInt(storageData.OverviewSorting)
        data.AvailableDaysNr = parseInt(storageData.AvailableDaysNr)
        data.CarRentalType = storageData.CarRentalType ? parseInt(storageData.CarRentalType) : null
        data.CarRentalCategory = storageData.CarRentalCategory ? parseInt(storageData.CarRentalCategory) : null
      }
    } catch (err) {
      console.error('Could not get CarRentalOverview information from local storage')
    }

    this.setState({
      requestData: {
        ...this.state.requestData,
        OverviewSorting: data.OverviewSorting,
        CalendarView: data.CalendarView,
        AvailableDaysNr: data.AvailableDaysNr,
        WeekType: data.WeekType,
        CarRentalType: data.CarRentalType,
        CarRentalCategory: data.CarRentalCategory
      }
    }, () => this.getCarRentalOverview())

    // Check if need to open capacity overview
    let location = this.props.router.location
    if (location.query.destination && location.query.destination === 'capacityoverview') {
      this.props.openOverlay('OrderCapacityOverview')
      this.props.router.replace({...location, query: {}})   // Reset query to only trigger once.
    }

    // this.observer = new MutationObserver((mutations) => {
    //   mutations.forEach((mutation) => {
    //     if (this.currentMirrorElement !== null) {
    //       let left = this.currentMirrorElement.style.left
    //       console.log('currentMirrorElement left', left)
    //     } else {
    //       console.log('style changed observed but no currentMirrorElement!!!')
    //     }

    //   })
    // })

    // document.addEventListener('mousedown', (e) => {
    //   console.log('mouse down', e, e.screenX)
    //   this.dragXStart = e.screenX
    // })
    // document.addEventListener('mouseup', (e) => {
    //   this.dragXDelta = e.screenX - this.dragXStart
    //   console.log('mouse up', e, e.screenX, 'delta', this.dragXDelta)

    // })

    // console.log('dragula', this.dragula)
    // document.addEventListener('mou')
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateDimensions)
    EventEmitter.removeListener('ORDER_SOCKET', this.updateFromOrderSocket)
  }

  updateDimensions () {
    let w = window
    let d = document
    let documentElement = d.documentElement
    let body = d.getElementsByTagName('body')[0]
    let width = w.innerWidth || documentElement.clientWidth || body.clientWidth
    let height = w.innerHeight || documentElement.clientHeight || body.clientHeight
    this.setState({
      dimensions: {
        width: width,
        height: height
      }
    })
  }

  setupDragula () {
    let containerClass = 'car-row-content'
    let containerDomCollection = ReactDOM.findDOMNode(this).getElementsByClassName(containerClass)
    let containers = []
    for (let i = 0; i < containerDomCollection.length; i++) {
      containers.push(containerDomCollection[i])
    }

    var options = {
      direction: 'vertical',
      revertOnSpill: true,
      accepts: (el, target, source, sibling) => {
        if (target.className.includes(containerClass)) {
          return true
        }
        return true
      }
    }
    // to handle mobile scrolling when dragging elements
    let moveList = document.querySelectorAll('div.drag-handle-class')
    if (moveList) {
      moveList.forEach(move => {
        move.addEventListener('touchmove', event => event.preventDefault())
      })
    }
    if (this.dragula !== null) {
      this.dragula.destroy()
    }
    this.dragula = new Dragula(containers, options)
    .on('over', (el, container) => {
      let mirrors = document.getElementsByClassName('gu-mirror')
      if (mirrors.length > 0) {
        let mirror = mirrors[0]
        this.currentMirrorElement = mirror
        this.currentContainer = container
      }
    })
    .on('drop', (el, target, source, sibling) => {
      if (el.style.display !== 'block') el.style.display = 'block'
      this.initiateMove(el, target, source, sibling)
      this.dragula.cancel()
    })
  }

  initiateMove (el, target, source, sibling) {
    let sourceId = parseInt(source.dataset.id)
    let targetId = parseInt(target.dataset.id)
    if (sourceId === targetId) return
    let request = {
      OverviewRequest: this.state.requestData,
      CarId: targetId,
      FromCarId: el.dataset.periodid && el.dataset.periodid !== '0' ? undefined : sourceId,
      OrderId: el.dataset.id,
      FromDate: el.dataset.fromdate,
      CarRentalPeriodId: el.dataset.periodid
    }

    this.props.MoveOrderCarRental(request).then((res) => {
      this.setNewOverview(res.data)
      // window.toastr.success(translation('1909'), translation('13424'))
    }, () => {
      window.toastr.error(translation('12339'), translation('216'))
    })
  }

  setNewOverview (data) {
    this.setState({
      requestData: {
        ...this.state.requestData,
        CalendarDirection: 0,
        CurrentViewRange: data.CurrentViewRange
      },
      CalendarData: {
        CalendarText: data.CalendarText,
        CalendarTextDictionaryKey: data.CalendarTextDictionaryKey
      },
      Days: data.Days,
      Cars: data.Cars
    }, () => {
      this.setupDragula() // has to be run after the order elements has been rendered
    })
  }

  getCarTypes () {
    this.props.GetCarTypes().then((res) => {
      this.setState({
        carTypes: res.data
      })
    })
  }

  getCarClasses () {
    this.props.GetCarClasses().then((res) => {
      this.setState({
        carCategories: res.data
      })
    })
  }
  getCarRentalOverview () {
    this.props.GetCarRentalOverview(this.state.requestData).then((res) => {
      this.setNewOverview(res.data)
    }, () => {
      window.toastr.error(translation('15160'), translation('216'))
    })
  }

  setLocalStorage () {
    let carRentalOverviewSettings = {
      OverviewSorting: this.state.requestData.OverviewSorting,
      AvailableDaysNr: this.state.requestData.AvailableDaysNr,
      CalendarView: this.state.requestData.CalendarView,
      WeekType: this.state.requestData.WeekType,
      CarRentalType: this.state.requestData.CarRentalType,
      CarRentalCategory: this.state.requestData.CarRentalCategory
    }
    window.localStorage.setItem('carRentalOverviewSettings', JSON.stringify(carRentalOverviewSettings))
    this.getCarRentalOverview()
  }

  renderAvailableDaysNr () {
    let options = []
    for (let nr = 0; nr < 16; nr++) {
      let label = translation(381)
      if (nr > 0) label = `${nr} ${translation(nr > 1 ? 503 : 483).toLowerCase()}`
      if (nr > 14) label = `> ${nr - 1} ${translation(503).toLowerCase()}`
      options.push(<option value={nr}>{label}</option>)
    }
    return options
  }

  renderHeaderItems () {
    // const { carTypes, carCategories } = this.props
    const { requestData, carTypes, carCategories } = this.state

    const renderMiddleCalendarText = () => {
      let text = ''
      if (this.state.CalendarData.CalendarTextDictionaryKey !== null) {
        text = translation(this.state.CalendarData.CalendarTextDictionaryKey) + ' '
      }
      if (this.state.CalendarData.CalendarText !== null) {
        text += this.state.CalendarData.CalendarText
      }
      return (
        <span>
          {text}
        </span>
      )
    }
    const rangeSwitchOnClick = (direction) => {
      this.setState({
        requestData: {
          ...this.state.requestData,
          CalendarDirection: direction
        }
      }, () => {
        this.getCarRentalOverview()
      })
    }
    const onChange = (e) => {
      let value = parseInt(e.target.value)
      if (e.target.name === 'CalendarView') {
        this.setState({
          requestData: {
            ...this.state.requestData,
            CalendarDirection: null,
            CurrentViewRange: null,
            CalendarView: value,
            WeekType: 0
          }
        }, this.setLocalStorage)
      } else if (e.target.name === 'OverviewSorting' && value === 0) {
        this.setState({
          requestData: {
            ...this.state.requestData,
            AvailableDaysNr: 0,
            [e.target.name]: value
          }
        }, this.setLocalStorage)
      } else {
        if (e.target.name === 'CarRentalType' || e.target.name === 'CarRentalCategory') {
          value = value === 0 ? null : value
        }
        let resetCategory = e.target.name === 'CarRentalType' && this.state.requestData.CarRentalCategory !== null
        this.setState({
          requestData: {
            ...this.state.requestData,
            CarRentalCategory: resetCategory ? null : this.state.requestData.CarRentalCategory,
            [e.target.name]: value
          }
        }, this.setLocalStorage)
      }
    }

    const renderTypes = (val, key) => {
      return (
        <option key={key} value={val.Id}>{val.Name}</option>
      )
    }

    const renderCategories = (category, key) => {
      let cat = parseInt(category.Id)
      if (requestData.CarRentalType === null || requestData.CarRentalType === 1 && vanCategories.includes(cat) || requestData.CarRentalType === 2 && passengerCategories.includes(cat)) {
        return <option key={key} value={cat}>{category.Name}</option>
      }
    }
    const usedRentLog = this.props.auth.carRentalSystem === CarRentalSystemTypes.RENTLOG
    let vanCategories = [3, 4, 5]
    let passengerCategories = [1, 2, 4, 5]
    return (
      <div className='carrental__tabs noselect'>
        <Inline>
          <div className='middleActions'>
            <Inline spacing={0}>
              <div>
                <Inline spacing={0}>
                  <PreviousButton size='m' onClick={rangeSwitchOnClick.bind(this, 1)} />
                  <div className='middle'>
                    {renderMiddleCalendarText()}
                  </div>
                  <NextButton size='m' onClick={rangeSwitchOnClick.bind(this, 2)} />
                </Inline>
              </div>
              <DropDown size='m' name='CalendarView' onChange={onChange} value={requestData.CalendarView}>
                <option value={0}>{translation('250')}</option>
                <option value={1}>{translation('15140')}</option>
              </DropDown>
              {requestData.CalendarView === 0 && (
                <DropDown size='m' name='WeekType' onChange={onChange} value={requestData.WeekType}>
                  <option value={0}>{translation('15208')}</option>
                  <option value={1}>{translation('15141')}</option>
                </DropDown>
              )}
              <DropDown size='m' name='OverviewSorting' onChange={onChange} value={requestData.OverviewSorting}>
                <option value={0}>{translation(16792)}</option>
                <option value={1}>{translation(16809)}</option>
              </DropDown>
              {requestData.OverviewSorting === 1 && (
                <DropDown size='m' minWidth={'120px'} name='AvailableDaysNr' onChange={onChange} value={requestData.AvailableDaysNr}>
                  {this.renderAvailableDaysNr()}
                </DropDown>
              )}
              <DropDown size='m' name='CarRentalType' onChange={onChange} value={requestData.CarRentalType || 0}>
                <option value={0}>{translation(332)}</option>
                {carTypes.map(renderTypes)}
              </DropDown>
              <DropDown size='m' name='CarRentalCategory' onChange={onChange} value={requestData.CarRentalCategory || 0} disabled={!usedRentLog && requestData.CarRentalType === null}>
                <option value={0}>{translation(1230)}</option>
                {carCategories.map(renderCategories)}
              </DropDown>
            </Inline>
          </div>
        </Inline>
        {false && (
          <div className='actions'>
            <button className='button primary'>
              <img src='/images/icons/circle_plus22.png' />
              {translation('15107')}
            </button>
          </div>
        )}
      </div>
    )
  }

  dimensionShow (dimensions) {
    let show = false
    dimensions.map((val, key) => {
      if (!show) {
        let higherThan = val[0]
        let lessThan = val[1]
        let width = this.state.dimensions.width
        if (width > higherThan && width <= lessThan) show = true
      }
    })
    return show
  }

  SetCreateNewOrderValues (show, carRentalId, pickupDate) {
    let defaultInfo
    if (show) {
      defaultInfo = {
        date: pickupDate,
        carRentalId: carRentalId
      }
    }
    this.props.triggerPopup(show)
    this.setState({
      createOrderPopup: {
        show: show,
        defaultCreateOrderInfo: defaultInfo
      }
    })
  }

  updateFromOrderSocket (json) {
    if (json.Type === 'ORDER_CREATED') this.getCarRentalOverview()
    if (json.Type === 'ORDER_UPDATE' && json.Data.CarRentalId !== undefined && json.Data.CarRentalId !== null) this.getCarRentalOverview()
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    const renderCarRow = (car, carRowIndex) => {
      const renderCarOrder = (order, carOrderIndex) => {
        return <CarOrder order={order} router={this.props.router} key={'carorder_' + carRowIndex + '_' + carOrderIndex} />
      }
      // do not show orders that end before first day of calendar
      let carOrders = car.Orders
      let calendarStart = this.state.Days[0].Date
      carOrders = carOrders.filter(x => x.FromDate >= calendarStart || x.ToDate > calendarStart)
      return <CarRow key={'carrow_' + car.Id + '_' + carRowIndex} setCreateOrderValues={this.SetCreateNewOrderValues} car={car} maxConflicts={car.MaxIndex} days={this.state.Days}>{carOrders.map(renderCarOrder)} </CarRow>
    }
    const renderHeaderDay = (day, dayIndex) => {
      let dayCount = this.state.Days.length
      if (dayCount <= 0) dayCount = 1
      let style = {
        // Somehow Edge is broken when using 100%... broken as always.
        width: 'calc(99.97% / ' + dayCount + ')'
      }
      let dayClass = 'day'
      if (day.Active) {
        dayClass += ' active'
      } else if (day.IsClosed) {
        dayClass += ' closed'
      }
      let dayText = ''
      if (this.dimensionShow([[0, 740]])) {
        dayText = translation(day.ShortTextDictionaryKey)
      } else {
        if (day.TextDictionaryKey !== undefined && day.TextDictionaryKey !== null) {
          dayText = translation(day.TextDictionaryKey) + ' '
        }
        if (day.Text !== undefined && day.Text !== null) {
          dayText += day.Text
        }
      }
      if (!day.IsClosed && day.NrCarsArrived !== null && !this.dimensionShow([[0, 515]])) {
        dayText += ' (' + day.NrCarsArrived + ')'
      }

      return (
        <div key={'header_' + dayIndex} className={dayClass} style={style}>
          <span>{dayText}</span>
        </div>
      )
    }
    const renderHeaderDays = () => {
      return (
        <div className='headerDays'>
          <div className='margin icon'><img src='/images/svgs/menuicons/lend-White.svg' /></div>
          <div className='days'>
            {this.state.Days.map(renderHeaderDay)}
          </div>
          <div className='margin right' />
          <div className='clearfix' />
        </div>
      )
    }
    return (
      <div className='carrentaloverview-screen'>
        {/* this.renderHeaderItems() */}
        <StickyContainer renderContent={this.renderHeaderItems} order={0} specificIndex={25} />
        <div className='row clearfix' />
        <div className='rentalCarsBoard noselect'>
          <StickyContainer renderContent={renderHeaderDays} order={1} />
          <div className='row-container'>
            {this.state.Cars.map(renderCarRow)}
          </div>
        </div>
        <NewOrdersModal router={this.props.router}
          show={this.state.createOrderPopup.show}
          carRentalDefaultInfo={this.state.createOrderPopup.defaultCreateOrderInfo}
          onClose={this.SetCreateNewOrderValues.bind(this, false)}
          bodyShop />
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    carTypes: state.common.enums_new.CarRentalTypes,
    carCategories: state.common.enums_new.CarRentalCategories
  }
}

export default connect(mapStateToProps, {
  GetCarRentalOverview,
  MoveOrderCarRental,
  NewOrdersModal,
  triggerPopup,
  GetCarTypes,
  GetCarClasses,
  openOverlay
})(CarRentalOverview)



// WEBPACK FOOTER //
// ./src/app/pages/CarRentalOverview/index.js